import { EmailData } from '../utils/emailFetcher';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export const emailApiService = {
  /**
   * Fetch order emails from the backend API
   */
  fetchOrderEmails: async (): Promise<EmailData[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/email/fetch`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch emails');
      }

      return data.emails;
    } catch (error) {
      console.error('Error fetching emails from API:', error);
      throw error;
    }
  },

  /**
   * Test the email connection
   */
  testEmailConnection: async (): Promise<boolean> => {
    try {
      const response = await fetch(`${API_BASE_URL}/email/test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Error testing email connection:', error);
      return false;
    }
  }
};
